import React from 'react';
import ReactDOMServer from 'react-dom/server';
import ReactDOM from 'react-dom';

import { Meteor } from 'meteor/meteor';
import { Router, Link, browserHistory, withRouter } from 'react-router';
import Moment from 'react-moment';
import moment from 'moment';
import { HTTP } from 'meteor/http';
import { Base64 } from 'meteor/base64';
import { Tracker } from 'meteor/tracker';
var RingLoader = require('halogen/PulseLoader');

import { CreateFlightComponent } from '../flights/component-create-flight';
import { HistoryFlightComponent } from '../flights/component-history-flight';

var DatePicker = require("react-bootstrap-date-picker");
import {
	Col,
	BPanel,
	Table,
	Button,
	MenuItem,
	Breadcrumb,
	Modal,
	FormControl,
	FormGroup,
	ControlLabel,
	Alert,
	PanelTabContainer,
	Nav,
	NavItem,
	Icon,
	PanelHeader,
	PanelBody,
	Grid,
	Panel,
	Row,
	Tab,

} from '@sketchpixy/rubix';
import { TunelPayementComponent } from './components/component-tunnel-payement';

import { Reservations } from '../../collections/reservations/reservations';
import { Addresses } from '../../collections/reservations/addresses';
import { Passengers } from '../../collections/reservations/passengers';
import { Payments } from '../../collections/reservations/payments';
import { Flights } from '../../collections/flights/flights';
import { Reactive } from '../common/Reactive.mixin.js';
import { AddPassengersComponent } from './components/component-add-passengers';
import { BillingComponent } from './components/component-billing';

@withRouter
@Reactive({
	subscriptions: [{name: 'reservation', param: 'id'}, "flights-type", "users"],
})
export default class ReservationsViewPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.state.reservation = null;
		props.ready.then(() => {
			Tracker.autorun(() => {
				this.setState({
					'reservation': Reservations.findOne({_id: this.props.params.id}),
					'flight': Flights.findOne({reservationIds: {$in: [this.props.params.id]}}),
					'payments': Payments.find({reservation: this.props.params.id}).fetch(),
					'activeTab': '',
				});

			});

			if(this.state.reservation) {
				this.state.createdAt = moment(this.state.reservation.createdAt).format();
				if(this.state.reservation.period == "Tous les jours") {
					this.state.reservation.period = "Libre date";
				}
			}

			Reservations.update(this.state.reservation._id, { "$set": { color: this.state.reservation.getFlightColor() }} );
		});
	}

	handleActiveState(eventKey) {
		this.setState({
			activeTab: eventKey
		});
	}

	deleteReservation() {
		if(confirm('Êtes-vous sûr de vouloir supprimer cette réservation ?')) {
			Reservations.remove(this.props.params.id);
			this.props.router.push('/reservations');
		}
	}

	cancelProgramme() {
		if(confirm('Êtes-vous sûr de vouloir annuler cette programmation ?')) {
			if(this.state.flight)
				this.state.flight.removeReservation(this.state.reservation._id);

			Reservations.update(this.state.reservation._id, { "$set": {scheduledAt: null}});
		}
	}

	calculBetterPrice(passenger) {

		if(passenger.age <= 12 && this.state.reservation.getFlightType().priceEnfant)
			return this.state.reservation.getFlightType().priceEnfant;

		if(this.state.reservation.period == 'SEMAINE' && this.state.reservation.getFlightType().priceSemaine)
			return this.state.reservation.getFlightType().priceSemaine;

		if(this.state.reservation.getFlightType()) {
			return this.state.reservation.getFlightType().priceLibreDate;
		}

		let price = prompt("Prix pour ce passager", "");

		return price;
	}

	addPassenger(event) {
		if(this.state.passengers && this.state.passengers.length >= this.state.maxPassengers) {
			Messenger().post({
				message: "Erreur, ce vol est limité à " + this.state.maxPassengers + " passagers",
				type: "error"
			});
			return;
		}

		let params = {
			'firstName' : ReactDOM.findDOMNode(this.refs.passenger_first_name).value.trim(),
			'lastName' : ReactDOM.findDOMNode(this.refs.passenger_last_name).value.trim(),
			'age' : ReactDOM.findDOMNode(this.refs.passenger_age).value.trim(),
			'weight' : ReactDOM.findDOMNode(this.refs.passenger_weight).value.trim(),
			'phone' : ReactDOM.findDOMNode(this.refs.passenger_phone).value.trim(),
			'email' : ReactDOM.findDOMNode(this.refs.passenger_email).value.trim(),
			'info' : ReactDOM.findDOMNode(this.refs.passenger_info).value.trim(),
			'mobility' : JSON.parse(ReactDOM.findDOMNode(this.refs.passenger_mobility).value),
		};

		params.price = this.calculBetterPrice(params) ? this.calculBetterPrice(params) : 0;

		ReactDOM.findDOMNode(this.refs.passenger_first_name).value = '';
		ReactDOM.findDOMNode(this.refs.passenger_last_name).value = '';
		ReactDOM.findDOMNode(this.refs.passenger_age).value = '';
		ReactDOM.findDOMNode(this.refs.passenger_weight).value = '';
		ReactDOM.findDOMNode(this.refs.passenger_phone).value = '';
		ReactDOM.findDOMNode(this.refs.passenger_info).value = '';

		let _id = Passengers.insert(params);
		let passengers = this.state.reservation.passengers;
		passengers.push(_id);

		Reservations.update(this.state.reservation._id, { "$set": { passengers: passengers }} );
		Reservations.update(this.state.reservation._id, { "$set": { price: (parseFloat(this.state.reservation.price) + parseFloat(params.price)) }} );

		Messenger().post({
			message: 'Le passager a bien été ajouté.',
			type: "success"
		});

		this.props.subscriptions['reservation'].clear();
		this.setState({
			'passengersLoading': true
		});

		let that = this;
		window.setTimeout(function() {
			that.setState({
				'passengersLoading': false,
			});
		}, 2000);
		//this.renderPassengers(true);

	}

	sendBillet() {
		if(confirm('Êtes-vous sûr de vouloir envoyer le mail ?')) {

			if(!this.state.reservation.getSubscriber().email) {
				Messenger().post({
	              message: "Cette réservation n'a pas d'email !",
	              type: "error"
	            });

				return ;
			}

			let mailSending = 0;
			if(!this.state.reservation.mailSending)
				mailSending = 1;
			else
				mailSending = this.state.reservation.mailSending + 1;


			let infoReservation = '';
			if(this.state.reservation.infoReservation) {
				infoReservation = this.state.reservation.infoReservation + ' - Billet envoyé le ' + moment().format('DD/MM/YYYY') + ' par ' + Meteor.user().profile.firstName + ' ' + Meteor.user().profile.lastName;
			} else {
				infoReservation = 'Billet envoyé le ' + moment().format('DD/MM/YYYY') + ' par ' + Meteor.user().profile.firstName + ' ' + Meteor.user().profile.lastName;
			}

			console.log('infoReservation', infoReservation);

			Reservations.update(this.state.reservation._id, { "$set": {
				mailSending: mailSending,
				state: 5,
				infoReservation: infoReservation
			}});

			this.state.reservation.sendBillet();
		};
	}

	openPopUp(urlToOpen) {
	  var popup_window=window.open(urlToOpen,"myWindow","toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=400, height=400");
	  try {
	    popup_window.focus();
	  }
	  catch (e) {
	    alert("Les fenêtes Pop-up sont bloquées ! Pour télécharger ce document, merci de les débloquer.");
	  }
	}

	downloadBill() {

		let data = {
			'reservation': this.state.reservation,
			'flight': this.state.reservation.getFlightType(),
			'passengers': this.state.reservation.getPassengers(),
			'subscriber': this.state.reservation.getSubscriber(),
			'delivery': this.state.reservation.getDelivery(),
			'flighted': this.state.reservation.getFlight(),
			'options' : this.state.reservation.getOptions(),
			'payments': this.state.payments
		};

		if(this.state.reservation.isPartners())
			data.partner = this.state.reservation.getPartner();

		console.log('data', data);

		HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=facture', {
		  data
		}, (error, result) => {
			result = JSON.parse(result.content);
			this.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
		});

	}

	downloadBillet() {

		let data = {
			'reservation': this.state.reservation,
			'period': this.state.reservation.getPeriod(),
			'place': this.state.reservation.getPlace(),
			'flight': this.state.reservation.getFlightType(),
			'passengers': this.state.reservation.getPassengers(),
			'subscriber': this.state.reservation.getSubscriber(),
			'delivery': this.state.reservation.getDelivery(),
			'password': moment(this.state.reservation.createdAt).format('X').slice(-4)
		};

		data.reservation.expireAt = moment(data.reservation.billAt, 'DD-MM-YYYY').add(2, 'years').format('DD/MM/YYYY');

		HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=billet', {
		  data
		}, (error, result) => {
			result = JSON.parse(result.content);
			this.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
		});

	}

	downloadBilletPrint() {
		let data = {
			'reservation': this.state.reservation,
			'period': this.state.reservation.getPeriod(),
			'place': this.state.reservation.getPlace(),
			'flight': this.state.reservation.getFlightType(),
			'passengers': this.state.reservation.getPassengers(),
			'subscriber': this.state.reservation.getSubscriber(),
			'delivery': this.state.reservation.getDelivery(),
			'password': moment(this.state.reservation.createdAt).format('X').slice(-4)
		};

		data.reservation.expireAt = moment(data.reservation.billAt, 'DD-MM-YYYY').add(2, 'years').format('DD/MM/YYYY');

		HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=billet-print', {
		  data
		}, (error, result) => {
			result = JSON.parse(result.content);
			this.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
		});

	}

	downloadBDR() {

		let data = {
			'reservation': this.state.reservation,
			'flight': this.state.reservation.getFlightType(),
			'passengers': this.state.reservation.getPassengers(),
			'subscriber': this.state.reservation.getSubscriber(),
			'delivery': this.state.reservation.getDelivery(),
			'payments': this.state.payments,
			'partner': this.state.reservation.getAuthor()
		};

		HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=bdr', {
		  data
		}, (error, result) => {
			result = JSON.parse(result.content);
			this.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
		});

	}

	removePassenger(event) {
		if(confirm('Êtes-vous sûr de vouloir supprimer ce passager ?')) {

			let passenger = Passengers.findOne(event.target.value);

			Reservations.update(this.state.reservation._id, { "$set": { passengers: _.without(this.state.reservation.passengers, event.target.value) }} );
			Reservations.update(this.state.reservation._id, { "$set": { price: (parseFloat(this.state.reservation.price) - parseFloat(passenger.price)) }} );

			Meteor.call('passengers.remove', event.target.value, (function (err, _id) {

	          if (err) {
	            Messenger().post({
	              message: err,
	              type: "error"
	            });
	            return;
	          }

	          Messenger().post({
	            message: 'Le passagé a bien été supprimé.',
	            type: "success"
	          });

	        }));

			this.props.subscriptions['reservation'].clear();
			this.setState({
				'passengersLoading': true
			});

			let that = this;
			window.setTimeout(function() {
				that.setState({
					'passengersLoading': false,
				});
			}, 2000);
		}
	}

	changePassengerPrice(target, event) {
		let update = {};
		update[target] = event.target.value;
		if(update[target] == '') {
			update[target] = 0;
		}

		Passengers.update(event.target.id, { "$set": update});
	}

	changePassengerInfos(target, event) {
		let update = {};
		update[target] = event.target.value;
		Passengers.update(event.target.id, { "$set": update});
	}

	changePaiementInfo(event) {
		Reservations.update(this.state.reservation._id, { "$set": {infoPayment: event.target.value}}, function(error, nb) {
			if (error)
				console.error(error);
		});
	}

	changeLinkReservation(event) {
		Reservations.update(this.state.reservation._id, {"$set": {linkReservation: event.target.value}});
	}

	changeReservationInfo(event) {
		console.log('event', event);
		Reservations.update(this.state.reservation._id, { "$set": {infoReservation: event.target.value}});
	}

	changeReservationPeriod(event) {
		Reservations.update(this.state.reservation._id, { "$set": {period: ReactDOM.findDOMNode(this.refs.period).value}});
	}

	changePassengerMobility(event) {
		Passengers.update(event.target.id, { "$set": {mobility: JSON.parse(event.target.value)}});
	}

	changeSubscriberInfo(target, event) {
		let update = {};
		update[target] = event.target.value;
		Addresses.update(this.state.reservation.getSubscriber()._id, { "$set": update});
	}

	changeDeliveryInfo(target, event) {
		let update = {};
		update[target] = event.target.value;
		Addresses.update(this.state.reservation.getDelivery()._id, { "$set": update});
	}

	selectPayment(evt) {
		if(evt) {
			Reservations.update(this.state.reservation._id, { "$set": {payment: parseInt(evt.target.value)}});
		}
	}

	allowReservationStatut() {
		return (!this.state.reservation.isPartners() || (this.state.reservation.getPartner() && this.state.reservation.getPartner().profile.billType == 'standard'));
	}

	renderDownloadBill() {
		if(this.state.reservation.state > 2) {
			return (
				<Button bsStyle="primary" onClick={this.downloadBill.bind(this)}>Télécharger la facture</Button>
			);
		} else {
			return (
				<Button bsStyle="primary" disabled>Télécharger la facture</Button>
			);
		}
	}

	renderDownloadBillet() {
		if(this.state.reservation.state > 2) {
			return (
				<span>
					<Button bsStyle="primary" onClick={this.downloadBillet.bind(this)}>Télécharger le billet</Button>&nbsp;&nbsp;
					<Button bsStyle="primary" onClick={this.downloadBilletPrint.bind(this)}>Billet à imprimer</Button>&nbsp;&nbsp;
					<Button bsStyle="warning" onClick={this.sendBillet.bind(this)}>Envoyer le billet {this.state.reservation.mailSending > 0 && <span>({this.state.reservation.mailSending})</span>}</Button>
				</span>
			);
		} else {
			return (
				<Button bsStyle="primary" disabled>Télécharger le billet</Button>
			);
		}
	}

	renderPassengers() {
		if(this.state.passengersLoading) {
			return (<div>chargement...</div>);
		}
		return this.state.reservation.getPassengers().map((passenger, index) => (
			<Col sm={6}>
				<Table striped bordered hover responsive>
					<tbody>
						<tr>
							<td><Icon bundle='fontello' glyph='user'/></td>
							<td>Passager n°{index+1}</td>
						</tr>
						<tr>
							<td>NOM</td>
							<td><FormControl type="text" id={passenger._id} ref="passenger_lastName" defaultValue={passenger.lastName} onChange={this.changePassengerInfos.bind(this, 'lastName')}/></td>
						</tr>
						<tr>
							<td>PRÉNOM</td>
							<td><FormControl type="text" id={passenger._id} ref="passenger_firstName" defaultValue={passenger.firstName} onChange={this.changePassengerInfos.bind(this, 'firstName')}/></td>
						</tr>
						<tr>
							<td>AGE</td>
							<td><FormControl type="text" id={passenger._id} ref="passenger_age" defaultValue={passenger.age} onChange={this.changePassengerInfos.bind(this, 'age')}/></td>
						</tr>
						<tr>
							<td>POIDS</td>
							<td><FormControl type="text" id={passenger._id} ref="passenger_weight" defaultValue={passenger.weight} onChange={this.changePassengerInfos.bind(this, 'weight')}/></td>
						</tr>
						<tr>
							<td>PORTABLE / TÉL</td>
							<td><FormControl type="text" id={passenger._id} ref="passenger_phone" defaultValue={passenger.phone} onChange={this.changePassengerInfos.bind(this, 'phone')}/></td>
						</tr>
						<tr>
							<td>EMAIL</td>
							<td><FormControl type="text" id={passenger._id} ref="passenger_email" defaultValue={passenger.email} onChange={this.changePassengerInfos.bind(this, 'email')}/></td>
						</tr>
						<tr>
							<td>Info</td>
							<td><FormControl type="text" id={passenger._id} ref="passenger_info" defaultValue={passenger.info} onChange={this.changePassengerInfos.bind(this, 'info')}/></td>
						</tr>
						<tr>
							<td>Prix (€)</td>
							<td><FormControl type="text" id={passenger._id} ref="passenger_price" defaultValue={passenger.price} onChange={this.changePassengerPrice.bind(this, 'price')}/></td>
						</tr>
						<tr>
							<td>Mobilité réduite</td>
							<td>
								<FormControl id={passenger._id} defaultValue={passenger.mobility} onChange={this.changePassengerInfos.bind(this, 'mobility')} componentClass="select" type="select" ref="passenger_mobility">
									<option value={false}>Non</option>
									<option value={true}>Oui</option>
								</FormControl>
							</td>
						</tr>
						<tr>
							<td>&nbsp;</td>
							<td><Button bsStyle="danger" value={passenger._id} onClick={this.removePassenger.bind(this)}>Supprimer</Button></td>
						</tr>
					</tbody>
				</Table>
			</Col>
		));
	}

	renderOptions() {

		return (
			<li>-</li>
		);

		return this.state.reservation.getOptions().map((option) => (
			<li>{option.title}: {option.price}€/pers</li>
		));
	}

	renderPromotions() {

		return this.state.reservation.getPromotions().map((promotion) => (
			<li>{promotion.title}: {promotion.price}€/pers</li>
		));
	}

	render() {

	  	if(!this.props.isReady || !this.state.reservation) {
	  		return (
	  			<RingLoader/>
	  		);
	  	}

		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/reservations">Reservations</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item active>
						{this.state.reservation.id_billet &&
							<span>Réservation n°{this.state.reservation.id_billet}</span>
						}
					</Breadcrumb.Item>
				</Breadcrumb>

				{!_.includes(Meteor.user().roles, 'partner') && this.state.reservation.getPartner() && _.includes(this.state.reservation.getPartner().roles, 'partner') &&
				<Alert bsStyle="warning">
					<span>Réservation du partenaire { this.state.reservation.getAuthor() }</span>
				</Alert>
				}

				<PanelTabContainer id='panel-body-header-tab-footer' defaultActiveKey="informations">
			 		<Panel>
			 		  <PanelHeader className='bg-green fg-white' style={{ display: 'block' }}>
			 			<Nav bsStyle="tabs" className='plain' onSelect={::this.handleActiveState}>
			 			  <NavItem eventKey="informations">
								Informations
			 			  </NavItem>
							<NavItem eventKey="commande">
			 					Commande
			 			  </NavItem>
			 			  <NavItem eventKey="client">
			 					Client
			 			  </NavItem>
			 			  <NavItem eventKey="passagers">
								Passagers
			 			  </NavItem>
							{!_.includes(Meteor.user().roles, 'partner') &&
							<NavItem eventKey="facturation">
								Facturation
							</NavItem>
							}
							<NavItem eventKey="actions">
								Actions
							</NavItem>
			 			</Nav>
			 		  </PanelHeader>
			 		  <PanelBody>
			 			<Grid>
			 			  <Row>
			 				<Col xs={12}>
			 				  <Tab.Content>
			 					<Tab.Pane eventKey="informations">
									<BPanel header="Informations">
									<Table striped bordered condensed hover responsive>
										<tbody>
											<tr>
												<td>Date de la commande</td>
												<td>{moment(this.state.reservation.createdAt).format("DD/MM/Y")}</td>
											</tr>
											<tr>
												<td>N° Billet</td>
												<td>{this.state.reservation.id_billet}</td>
											</tr>
											<tr>
												<td>Mot de passe</td>
												<td>{moment(this.state.reservation.createdAt).format('X').slice(-4)}</td>
											</tr>
											<tr>
												<td>Vol séléctionné</td>
												<td>{this.state.reservation.getFlightName()}</td>
											</tr>
											<tr>
												<td>Période {this.state.reservation.getPeriod()}</td>
												<td>
													<FormControl id="period" defaultValue={this.state.reservation.getPeriod()} onChange={this.changeReservationPeriod.bind(this, 'period')} componentClass="select" type="select" ref="period">
														<option value='Semaine uniquement'>Semaine uniquement</option>
														<option value='Libre date'>Libre date</option>
													</FormControl>
												</td>
											</tr>
											<tr>
												<td>Envol</td>
												<td>{this.state.reservation.getPlace()}</td>
											</tr>
											<tr>
												<td>Promotions séléctionnées</td>
												<td>{this.renderPromotions()}</td>
											</tr>
											<tr>
												<td>Prix</td>
												<td>{this.state.reservation.getPrice()}€</td>
											</tr>
											<tr>
												<td>Observation du client</td>
												<td>
													{this.state.reservation.infoClient && this.state.reservation.infoClient.split("\n").map(function(item) {
														return (
															<p>
																{item}
															</p>
														);
													})}
													{!this.state.reservation.infoClient &&
														<p>Aucune observation</p>
													}
												</td>
											</tr>
										</tbody>
									</Table>
									{this.state.reservation.codePromoReduction &&
									<Col sm={12}>
									<BPanel header="Code de réduction">
									<Col sm={4}>
										<p>Code : {this.state.reservation.codePromoName}</p>
									</Col>
									<Col sm={4}>
										<p>Valeur : {this.state.reservation.codePromoReduction}</p>
									</Col>
									<Col sm={4}>
										{this.state.reservation.codePromoType == 'percent' &&
											<p>Type : Pourcentage</p>
										}
										{this.state.reservation.codePromoType == 'euros' &&
											<p>Type : Euros</p>
										}
									</Col>
									</BPanel>
									</Col>
									}
								</BPanel>
			 					</Tab.Pane>
			 					<Tab.Pane eventKey="client">
									{this.state.reservation.getSubscriber() &&
										<BPanel header="SOUSCRIPTEUR">
											<Table striped bordered condensed hover responsive>
												<tbody>
													<tr>
														<td>Civilité</td>
														<td>{this.state.reservation.getSubscriber().civility}</td>
													</tr>
													<tr>
															<td>Nom / Prénom</td>
															<td><FormControl type="text" ref="subscriber_name" defaultValue={this.state.reservation.getSubscriber().name} onChange={this.changeSubscriberInfo.bind(this, 'name')}/></td>
													</tr>
													<tr>
															<td>N° / Voie</td>
															<td><FormControl type="text" ref="subscriber_street" defaultValue={this.state.reservation.getSubscriber().street} onChange={this.changeSubscriberInfo.bind(this, 'street')}/></td>
													</tr>
													<tr>
															<td>Code postal / Ville</td>
															<td><FormControl type="text" ref="subscriber_city" defaultValue={this.state.reservation.getSubscriber().city} onChange={this.changeSubscriberInfo.bind(this, 'city')}/></td>
													</tr>
													<tr>
															<td>Téléphone</td>
															<td><FormControl type="text" ref="subscriber_phone" defaultValue={this.state.reservation.getSubscriber().phone} onChange={this.changeSubscriberInfo.bind(this, 'phone')}/></td>
													</tr>
													<tr>
															<td>Email</td>
															<td><FormControl type="text" ref="subscriber_email" defaultValue={this.state.reservation.getSubscriber().email} onChange={this.changeSubscriberInfo.bind(this, 'email')}/></td>
													</tr>
												</tbody>
											</Table>
										</BPanel>
									}
									{this.state.reservation.getDelivery() &&
										<BPanel header="LIVRAISON DU BILLET (SI DIFFÉRENT)">
											<Table striped bordered hover responsive>
												<tbody>
													<tr>
															<td>Civilité</td>
															<td>{this.state.reservation.getDelivery().civility}</td>
													</tr>
													<tr>
															<td>Nom / Prénom</td>
															<td><FormControl type="text" ref="delivery_name" defaultValue={this.state.reservation.getDelivery().name} onChange={this.changeDeliveryInfo.bind(this, 'name')}/></td>
													</tr>
													<tr>
															<td>N° / Voie</td>
															<td><FormControl type="text" ref="delivery_street" defaultValue={this.state.reservation.getDelivery().street} onChange={this.changeDeliveryInfo.bind(this, 'street')}/></td>
													</tr>
													<tr>
															<td>Code postal / Ville</td>
															<td><FormControl type="text" ref="delivery_city" defaultValue={this.state.reservation.getDelivery().city} onChange={this.changeDeliveryInfo.bind(this, 'city')}/></td>
													</tr>
													<tr>
															<td>Téléphone</td>
															<td><FormControl type="text" ref="delivery_phone" defaultValue={this.state.reservation.getDelivery().phone} onChange={this.changeDeliveryInfo.bind(this, 'phone')}/></td>
													</tr>
												</tbody>
											</Table>
										</BPanel>
										}
			 					</Tab.Pane>
			 					<Tab.Pane eventKey="commande">
								<BPanel header="Etat de la commande">

									{this.allowReservationStatut() &&
									<div>
										<FormGroup controlId="formHorizontalEmail">
											<Col sm={4}>
												Statut de la commande
											</Col>
											<Col sm={8}>
												<TunelPayementComponent reservation={this.state.reservation} />
											</Col>
										</FormGroup>

										<hr/><br/>
										<FormGroup controlId="formHorizontalEmail">
											<Col sm={4}>
												Type de livraison :
											</Col>
											<Col sm={8}>
												{this.state.reservation.livraisonType == 0 &&
													<span>Billet seul</span>
												}
												{this.state.reservation.livraisonType == 1 &&
													<span>Billet + Facture</span>
												}
											</Col>
										</FormGroup>
										<FormGroup controlId="formHorizontalEmail">
											<Col sm={4}>
												Commande internet :
											</Col>
											<Col sm={8}>
												{this.state.reservation.id_internet &&
													<span>Oui - N°{this.state.reservation.id_internet}</span>
												}
												{!this.state.reservation.id_internet &&
													<span>Non</span>
												}
											</Col>
										</FormGroup>
										<br/><hr/>
									</div>
									}

									{!_.includes(Meteor.user().roles, 'partner') &&
									<div>
										<Col sm={4}>
											Billets liés :
										</Col>
										<Col sm={8}>
										<FormGroup controlId="formHorizontalEmail">
											<FormControl id="linkReservation" type="text" onChange={this.changeLinkReservation.bind(this)} defaultValue={this.state.reservation.linkReservation} />
										</FormGroup>
										</Col>

										<br/><hr/>
									</div>
									}

									{this.allowReservationStatut() &&
									<Col sm={6}>
										<p>Information sur le paiement : (visible sur facture)</p>
										<FormControl componentClass="textarea" rows="6" onChange={this.changePaiementInfo.bind(this)} defaultValue={this.state.reservation.infoPayment} />
									</Col>
									}

									<Col sm={6}>
										<p>Information sur la réservation :</p>
										<FormControl componentClass="textarea" rows="6" onChange={this.changeReservationInfo.bind(this)} defaultValue={this.state.reservation.infoReservation}/>
									</Col>

									<hr/>

									<FormGroup controlId="formHorizontalEmail">
										<Col sm={10}>
											<br/>{this.allowReservationStatut() && this.renderDownloadBill()} <hr/> {this.renderDownloadBillet()} <hr/> <Button bsStyle="primary" onClick={this.downloadBDR.bind(this)}>Télécharger le bon de réservation</Button>
										</Col>
									</FormGroup><br/><br/>

									{this.state.reservation.getAuthor() != '-' &&
										<Col sm={12}>
											<hr/>
											<p>Réservation effectuée par : { this.state.reservation.getAuthor() }</p>
										</Col>
									}
								</BPanel>

			 					</Tab.Pane>
			 					<Tab.Pane eventKey="facturation">
									{!_.includes(Meteor.user().roles, 'partner') &&
									<BillingComponent reservation={this.state.reservation} payments={this.state.payments}></BillingComponent>
									}
			 					</Tab.Pane>
			 					<Tab.Pane eventKey="passagers">
									<BPanel header="Passagers">
											{this.renderPassengers()}
									</BPanel>

									<BPanel header="Ajouter un passager">
											<FormGroup controlId="formHorizontalEmail" ref="addPassenger">
											<Col sm={12}>
												<Table striped bordered hover responsive>
													<tbody>
															<tr>
																<td>NOM</td>
																<td><FormControl type="text" ref="passenger_last_name"/></td>
															</tr>
															<tr>
																<td>PRÉNOM</td>
																<td><FormControl type="text" ref="passenger_first_name"/></td>
															</tr>
															<tr>
																<td>AGE</td>
																<td><FormControl type="text" ref="passenger_age"/></td>
															</tr>
															<tr>
																<td>POIDS</td>
																<td><FormControl type="text" ref="passenger_weight"/></td>
															</tr>
															<tr>
																<td>PORTABLE / TÉL</td>
																<td><FormControl type="text" ref="passenger_phone"/></td>
															</tr>
															<tr>
																<td>EMAIL</td>
																<td><FormControl type="text" ref="passenger_email"/></td>
															</tr>
															<tr>
																<td>INFO</td>
																<td><FormControl type="text" ref="passenger_info"/></td>
															</tr>
															<tr>
																<td>Mobilité réduite</td>
																<td>
																	<FormControl componentClass="select" type="select" ref="passenger_mobility">
																			<option value={false}>Non</option>
																			<option value={true}>Oui</option>
																	</FormControl>
																</td>
															</tr>
													</tbody>
												</Table>
												<Button bsStyle="success" onClick={this.addPassenger.bind(this)}>+ AJOUTER</Button>
											</Col>
										</FormGroup>
									</BPanel>
				 					</Tab.Pane>
									<Tab.Pane eventKey="actions">
										{ _.includes(Meteor.user().roles, 'god') &&
										<Col sm={4} className="text-center">
											<BPanel header="Suppression">
												<center>
													{ _.includes(Meteor.user().roles, 'god') &&
														<Button bsStyle="danger" onClick={this.deleteReservation.bind(this)}>Supprimer</Button>
													}
												</center>
											</BPanel>
										</Col>
										}

										<Col sm={4} className="text-center">
											<BPanel header="Historique">
												<HistoryFlightComponent
													reservation={this.state.reservation}>
												</HistoryFlightComponent>
											</BPanel>
										</Col>

										{!_.includes(Meteor.user().roles, 'partner') && this.state.reservation.state < 6 &&
										<Col sm={4} className="text-center">
											<BPanel header="Programmation">
												<center>
													{this.state.reservation.scheduledAt &&
														<p>
															La réservation a été programmé le <Moment format="DD/MM/YYYY">{this.state.reservation.scheduledAt}</Moment> le {this.state.reservation.getPeriodTime()} à {this.state.reservation.getPlace()}
															<br/><br/><Button bsStyle="danger" onClick={this.cancelProgramme.bind(this)}>Annuler</Button>
														</p>
													}

													{this.state.reservation.state < 6 &&
														<CreateFlightComponent
															reservation={this.state.reservation}>
														</CreateFlightComponent>

													}
												</center>
											</BPanel>
										</Col>
										}
									</Tab.Pane>
			 				  </Tab.Content>
			 				</Col>
			 			  </Row>
			 			</Grid>
			 		  </PanelBody>
			 		</Panel>
			 	  </PanelTabContainer>
			</div>
		);
	}
}

ReservationsViewPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/page-reservations-view.js
 **/